<template>

    <draggable class="dragArea" tag="div" :list="nests" :group="{ name: 'g1' }">

        <div class="inner-div" v-for="el in nests" :key="el.name">
            <p class="badge badge-dark px-4 py-2 my-0 d-block text-left">{{ el.name }}</p>
            <nested-draggable :nests="el.children" />
        </div>

    </draggable>

</template>
<script>
  import draggable from 'vuedraggable';
  export default {
    display: "Nested",
    props: {
      nests: {
        required: true,
        type: Array
      }
    },
    data() {
      return {
      };
    },
    components: {
      draggable
    },
  };
</script>
<style scoped>

    .dragArea {

        padding: 20px 15px;
        margin: 0 0 20px;
        background: rgba(4, 23, 56, 0.075);
        border-radius: 4px;
        position: relative;
        transition: all 0.25s;

    }

    .dragArea::after {

        position: absolute;
        bottom: 11px;
        content: 'Drag Area';
        left: 20px;
        opacity: 0.35;
        pointer-events: none;
        font-size: 12px;
        text-transform: uppercase;
        font-weight: bold;
        letter-spacing: 0.6px;
        display: none;

    }

    .dragArea:hover {

        /*padding: 40px 15px;*/

        /*display: block;*/

    }

    .dragArea:hover::after {

        /*display: block;*/

    }

    .inner-div::before {

        content: '';
        border: thin #333 solid;
        border-radius: 3px;
        top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px;
        z-index: 1;
        pointer-events: none;
        position: absolute;

    }

    .inner-div {
        position: relative;
    }

</style>